import React from 'react';
import { NavLink } from 'react-router-dom';
import SafeIcon from '../common/SafeIcon';
import { Logo, Avatar } from './Branding';
import { FiHome, FiUsers, FiFileText, FiCheckSquare, FiSettings, FiBell, FiSearch, FiInfo } from 'react-icons/fi';

export const Sidebar = () => {
  const navItems = [
    { path: '/', icon: FiHome, label: 'Radar Hub' },
    { path: '/vendors', icon: FiUsers, label: 'Directory' },
    { path: '/contracts', icon: FiFileText, label: 'Renewals' },
    { path: '/approvals', icon: FiCheckSquare, label: 'Workflows' },
    { path: '/guide', icon: FiInfo, label: 'Product Guide' },
    { path: '/settings', icon: FiSettings, label: 'Settings' },
  ];

  return (
    <div className="w-64 bg-[#0A0F1C] border-r border-slate-800 flex flex-col h-screen sticky top-0 hidden lg:flex shrink-0">
      <div className="p-8 flex items-center gap-4">
        <Logo size="md" />
        <div className="leading-none">
          <span className="text-xl font-black tracking-tighter text-white block">VENDOR</span>
          <span className="text-xl font-light tracking-[0.2em] text-yellow-400 block -mt-1">VISTA</span>
        </div>
      </div>
      
      <div className="flex-1 px-4 space-y-1.5 mt-4">
        <p className="px-4 text-[10px] font-bold text-slate-500 uppercase tracking-widest mb-4">Main Menu</p>
        {navItems.map((item) => (
          <NavLink
            key={item.path}
            to={item.path}
            className={({ isActive }) =>
              `flex items-center gap-3 px-4 py-3 rounded-xl transition-all duration-300 group relative ${
                isActive 
                  ? 'bg-yellow-400/10 text-yellow-400' 
                  : 'text-slate-400 hover:bg-slate-800/40 hover:text-slate-200'
              }`
            }
          >
            <SafeIcon icon={item.icon} className="text-lg relative z-10" />
            <span className="font-semibold text-sm relative z-10">{item.label}</span>
            <NavLink to={item.path} className={({isActive}) => isActive ? "absolute left-0 w-1 h-6 bg-yellow-400 rounded-r-full" : "hidden"} />
          </NavLink>
        ))}
      </div>
      
      <div className="p-6 mt-auto">
        <div className="bg-[#0F1626]/50 border border-slate-800 rounded-2xl p-5 text-center">
          <div className="flex justify-center mb-3 opacity-50">
            <Logo size="sm" />
          </div>
          <p className="text-[10px] text-slate-500 uppercase tracking-[0.2em] font-bold mb-1">Powered By</p>
          <p className="text-xs text-slate-400 font-medium whitespace-nowrap">LingLink AI & DigLab AI</p>
        </div>
      </div>
    </div>
  );
};

export const TopBar = () => {
  return (
    <div className="h-20 bg-[#0A0F1C]/90 backdrop-blur-xl border-b border-slate-800 flex items-center justify-between px-8 sticky top-0 z-50">
      <div className="flex items-center bg-[#0F1626] border border-slate-700/50 rounded-xl px-4 py-2.5 w-full max-w-md focus-within:border-yellow-400/50 focus-within:ring-1 focus-within:ring-yellow-400/20 transition-all">
        <SafeIcon icon={FiSearch} className="text-slate-500" />
        <input 
          type="text" 
          placeholder="Lookup suppliers, tax IDs, or contracts..." 
          className="bg-transparent border-none outline-none text-slate-200 ml-3 w-full placeholder-slate-600 text-sm"
        />
      </div>
      
      <div className="flex items-center gap-6 ml-4">
        <div className="hidden sm:flex items-center gap-2 px-3 py-1.5 bg-emerald-500/10 border border-emerald-500/20 rounded-full">
          <div className="w-1.5 h-1.5 rounded-full bg-emerald-400 animate-pulse"></div>
          <span className="text-[10px] font-bold text-emerald-400 uppercase tracking-wider">Live Monitoring</span>
        </div>

        <button className="relative p-2 text-slate-400 hover:text-yellow-400 transition-colors">
          <SafeIcon icon={FiBell} className="text-xl" />
          <span className="absolute top-2 right-2 w-2 h-2 bg-red-500 rounded-full border-2 border-[#0A0F1C]"></span>
        </button>

        <div className="h-8 w-px bg-slate-800"></div>

        <div className="flex items-center gap-3 pl-2">
          <div className="text-right hidden md:block">
            <p className="text-sm font-bold text-slate-200 leading-none">Alex Mercer</p>
            <p className="text-[10px] text-slate-500 font-bold uppercase tracking-wider mt-1">Enterprise Admin</p>
          </div>
          <Avatar 
            src="https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?auto=format&fit=crop&q=80&w=100&h=100" 
            name="Alex Mercer"
          />
        </div>
      </div>
    </div>
  );
};